<template>
  <div id="main">
    <div v-if="loaded" key="main">
      <div class="jumbotron" id="main-header">
        <div class="container-fluid">
          <div id="main-title">
            <span class="repias pull-right">
              <img class="img-responsive"
                   :src="require('@/assets/img/logo-repias.png')"/>
            </span>
            <router-link tag="a" to="/">
              <span class="title">
                {{ title.main }}
              </span>
              <br />{{ title.subtitle }}
            </router-link>
          </div>
        </div>
      </div>
      <navigation />
      <router-view />
      <c-footer/>
    </div>
    <transition name="fade">
      <div v-show="!loaded" class="loading" key="loading">
        <div class="loading-text text-center">
          <h1>SPIADI</h1>
          <sui-loading-text>Chargement en cours</sui-loading-text>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import navigation from '@/components/navigation'
import footer from '@/components/footer'
import sc from '@/sc/presentation'
import suiLoadingText from '@/sui/components/loadingtext'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'main-main',

  data: function () {
    return {
      show: true
    }
  },

  computed: {
    title: function () {
      return sc.title
    },

    ...mapState({
      loaded: state => state.cloud.loaded
    }),

    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn'
    })
  },

  components: {
    'navigation': navigation,
    'c-footer': footer,
    'sui-loading-text': suiLoadingText
  }
}
</script>
<style lang="less" scoped>
@import '~variables';

#main {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: stretch;

  .survey-alert {
    width: 100%;
    position: fixed;
    bottom: 0%;
    z-index: 10000;

    .alert {
      margin-bottom: 0rem;
      a {
        color: white;
      }
    }
  }
}

.loading {
  position: absolute;
  top: 0%;
  left: 0%;
  right: 0%;
  bottom: 0%;
  background-color: @brand-primary;
  z-index: 100000;

  .loading-text {
    position: absolute;
    font-family: Helvetica;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    h1 {
      font-size: 400%;
    }
  }
}

#main-header {
  background-color: @dark-base;
  margin-bottom: 0rem;
  padding-bottom: 0.8rem;
  padding-top: 0.8rem;

  #main-title {
    .repias {
      display: inline-block;
      height: 6.5rem;
      vertical-align: middle;
      img {
        height: 90%;
        margin-top: 0.3rem;
        background-color: rgba(255, 255, 255, 1);
        padding: 0.5rem;
        border-radius: 0.3rem;
      }
    }

    .title {
      font-size: 320%;
      line-height: 4rem;
    }
  }

  a {
    color: white;
  }

  a:active, a:hover, a:focus {
    outline: 0;
    color: white;
    text-decoration: none;
  }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 1.5s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
